import React from 'react'
import { actions } from '../actions/cognito';
import { actions as errorActions } from '../actions/error';
import { useCognitoProvider } from '../providers/CognitoContext';
import { useErrorProvider } from '../providers/ErrorProvider';
import cognitoUtils from '../utils/cognitoUtils';

export const useFetch = () => {

    const { dispatch } = useCognitoProvider();
    const cognito = cognitoUtils;
    const { state, dispatch: errorDispatch } = useErrorProvider();

    const interceptedFetch = async (url, data = {}) => {
        cognito.checkSession(
            () => { dispatch({ type: actions.LOG_OUT }); },
        )   
        const response = await window.fetch(url, data);
        if(response.status === 403) {
            errorDispatch({ 
                type: errorActions.CLOSE_AND_CALLBACK, 
                payload: {
                    message: 'Se han solicitado datos que no corresponden a este usuario. Se va a proceder a cerrar la sesión.',
                    onCloseCallback: () => {
                        dispatch({ type: actions.LOG_OUT });
                    }
                } 
            });
        }
        return response;
    }

    return {
        interceptedFetch
    }
}